import Form from "@/components/Form";
import { List } from "@/components/list/List";
import SaveButton from "@/components/SaveButton";
import { useProjectLimitsContext } from "./ProjectLimitsContext";
import { ProjectLimitUpsertButton } from "./ProjectLimitUpsertButton";

const ProjectLimitForm = () => {
  const { form, handleChangeLimitSubmit } = useProjectLimitsContext();

  return (
    <Form
      form={form}
      handleSubmit={handleChangeLimitSubmit}
      className="h-full gap-1"
    >
      <List.Content>
        <List.Status>
          <ProjectLimitUpsertButton />
        </List.Status>
      </List.Content>
      <footer className="flex p-2 justify-end gap-6">
        <SaveButton />
      </footer>
    </Form>
  );
};

export default ProjectLimitForm;
